import React, { Component } from "react";
import { styled } from '@mui/material/styles';
import { connect } from "react-redux";
import { compose } from "recompose";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Switch from "@mui/material/Switch";
import Collapse from "@mui/material/Collapse";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { parseClass } from "../../helpers/parser";
import { classNames } from "../../helpers/lines";

const PREFIX = 'FilterList';

const classes = {
  root: `${PREFIX}-root`,
  nested: `${PREFIX}-nested`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    width: "100%",
    maxWidth: 360,
    background: theme.palette.background.paper,
  },

  [`& .${classes.nested}`]: {
    paddingLeft: theme.spacing(4),
  }
}));

const checkboxValues = {
  booksIssued: "Bogpakke udleveret",
  contractReceived: "Kontrakt modtaget",
  confirmationSent: "Bekræftigelse sendt",
  admissionFeeReceived: "Indmeldelsesgebyr modtaget",
  studentCard: "Studiekort",
  consentSigned: "Samtykkeerklæring underskrevet",
  rulesSigned: "Regelsæt underskrevet",
  infoLetter: "Informations brev",
  introductionEmail: "Velkomst mail sendt",
  createdInSU: "Oprettet i SU",
  lectio: "Indskrevet i Lectio",
  workExperienceContract: "Praktik kontrakt",
  workExperienceContract2: "Praktik kontrakt 2",
  graduated: "Dimitteret",
  discharged: "Udmeldt",
};

class FilterList extends Component {
  render() {
    const { handleChange, removeKey,   query, selectedLine } = this.props;

    const classesForLine = classNames[selectedLine];

    return (
      <Root className={classes.root}>
        <List subheader={<ListSubheader>Filtre</ListSubheader>} dense={true}>
          {/* Hardcode the gender attribute since it's a string value and not boolean*/}
          <ListItem button onClick={() => removeKey("gender")}>
            <ListItemIcon>
              {"gender" in query ? (
                <CloseIcon color="secondary" />
              ) : (
                <VisibilityOffIcon />
              )}
            </ListItemIcon>
            <ListItemText primary={"Køn"} />
          </ListItem>
          <Collapse in={true} timeout="auto" unmountOnExit>
            <List component="div" disablePadding dense={true}>
              <ListItem
                button
                className={classes.nested}
                onClick={() => handleChange("gender")("male")}
              >
                {query["gender"] === "male" && (
                  <ListItemIcon>
                    <AccountCircle color="primary" />
                  </ListItemIcon>
                )}
                <ListItemText primary="Dreng" />
              </ListItem>
              <ListItem
                button
                className={classes.nested}
                onClick={() => handleChange("gender")("female")}
              >
                {query["gender"] === "female" && (
                  <ListItemIcon>
                    <AccountCircle color="primary" />
                  </ListItemIcon>
                )}
                <ListItemText primary="Pige" />
              </ListItem>
            </List>
          </Collapse>
          <ListItem button onClick={() => removeKey("class")}>
            <ListItemIcon>
              {"class" in query ? (
                <CloseIcon color="secondary" />
              ) : (
                <VisibilityOffIcon />
              )}
            </ListItemIcon>
            <ListItemText primary={"Hold"} />
          </ListItem>
          <Collapse in={true} timeout="auto" unmountOnExit>
            <List component="div" disablePadding dense={true}>
              {classesForLine.map((name, i) => {
                return (
                  <ListItem
                    key={i}
                    button
                    className={classes.nested}
                    onClick={() => handleChange("class")(name)}
                  >
                    {query["class"] === name && (
                      <ListItemIcon>
                        <AccountCircle color="primary" />
                      </ListItemIcon>
                    )}
                    <ListItemText primary={parseClass(name)} />
                  </ListItem>
                );
              })}
            </List>
          </Collapse>
          {Object.keys(checkboxValues).map((key, i) => {
            return (
              <ListItem key={i} button onClick={() => removeKey(key)}>
                <ListItemIcon>
                  {key in query ? (
                    <CloseIcon color="secondary" />
                  ) : (
                    <VisibilityOffIcon />
                  )}
                </ListItemIcon>
                <ListItemText primary={checkboxValues[key]} />
                <ListItemSecondaryAction>
                  <Switch
                    onChange={handleChange(key)}
                    checked={query[key] || false}
                    color="primary"
                  />
                </ListItemSecondaryAction>
              </ListItem>
            );
          })}
        </List>
      </Root>
    );
  }
}

const mapStateToProps = ({ students }) => {
  const { query } = students;
  return {
    query,
  };
};

export default compose(
  
  connect(mapStateToProps, null)
)(FilterList);
